export default __webpack_public_path__ + "static/media/school4.e812c507.webp";